import { css } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

import { SeparatorProps } from "./types";

const Separator = ({ isVertical, ...props }: SeparatorProps) => {
    const { gray200 } = colors;

    return (
        <div
            {...props}
            css={css({
                background: gray200,
                height: isVertical ? "unset" : "1px",
                width: isVertical ? "1px" : "100%"
            })}
        />
    );
};

export { Separator };
